import * as backend from '@/lib/backend';

import { trackError } from '@/lib/error_tracker';
import { trackEvent } from '@/lib/event_tracker';

export default async function navigateToCustomerPortal(
  dispatch,
  session,
  pathname,
  returnUrl = window.location.href
) {
  const { exception, error, response, data } = await backend.customerPortal(
    session,
    {
      returnUrl,
    }
  );

  if (error || exception) {
    trackError(session, 'Customer Portal Navigation Failed', exception, {
      pathname,
      ...(response
        ? {
            responseStatus: response && response.status,
          }
        : {}),
    });

    dispatch({
      type: 'setFlashMessage',
      data: {
        type: 'error',
        message: 'Failed to navigate to customer portal',
      },
    });

    // TODO(@alerting): this one should alert on Slack or something!
    trackError(session, 'Plan Subscription Failed', exception, {
      pathname,
      ...(response
        ? {
            responseStatus: response && response.status,
          }
        : {}),
    });

    return;
  }

  trackEvent(session, pathname, 'Customer Portal Navigated To');
  window.location.assign(data.url);
}
